import React from "react";
import "mobx-react-lite/batchingForReactDom";
import { render } from "react-dom";
import { HashRouter as Router } from "react-router-dom";
import { format } from "date-fns";
import { ja } from "date-fns/locale";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { blue } from "@material-ui/core/colors";
import { AuthStoreProvider } from "stores/AuthStore";
import { AccountFormStoreProvider } from "stores/AccountFormStore";
import "typeface-roboto";
import App from "./views/App";

class DateUtils extends DateFnsUtils {
  public getDatePickerHeaderText(date: Date) {
    return format(date, "MMMM d日", { locale: this.locale });
  }
  public getCalendarHeaderText(date: Date) {
    return format(date, "MMMM", { locale: this.locale });
  }
}

const theme = createMuiTheme({
  palette: { primary: blue },
});

render(
  <Router>
    <MuiThemeProvider theme={theme}>
      <MuiPickersUtilsProvider utils={DateUtils} locale={ja}>
        <AuthStoreProvider>
          <AccountFormStoreProvider>
            <App />
          </AccountFormStoreProvider>
        </AuthStoreProvider>
      </MuiPickersUtilsProvider>
    </MuiThemeProvider>
  </Router>,
  document.getElementById("root")
);
